export const homeConstants = {
    STUDENT_DEBT: 'STUDENT_DEBT'
    
};